// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3grrJ","title":"Header_title__1rHes","side":"Header_side__1LuKz"};